import React from 'react';
import {useStyles} from "../ArticleCategories.style";
import clsx from "clsx";
import ArticleCategoryRowProperties from "./ArticleCategoryRowProperties";
import ShowSellerBasicInfo from "../../../shared_components/Info/ShowSellerBasicInfo/ShowSellerBasicInfo";
import ButtonSize from "../../../ui_components/Button/ButtonSize";
import ButtonType from "../../../ui_components/Button/ButtonType";
import NewArticleCategoryButton from '../../../shared_components/Buttons/NewArticleCategory/NewArticleCategoryButton';

const ArticleCategoryRowSmall: React.FC<ArticleCategoryRowProperties> = ({articleCategory, onUpdate}) => {

    const classes = useStyles();


    return (
        <div className={clsx(classes.article_category_info_container_small)}>
            <ShowSellerBasicInfo autofill name={articleCategory.name} email={articleCategory.description}/>
            <div className={classes.menu_container_small}>
                <NewArticleCategoryButton
                    size={ButtonSize.SMALL}
                    onSave={onUpdate}
                    articleCategoryId={articleCategory.id}
                    showText={false}
                    type={ButtonType.SECONDARY}
                />
            </div>
        </div>
    )
}

export default ArticleCategoryRowSmall;

